import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { ChevronRightBold } from '@sorare/core/src/atoms/icons/ChevronRightBold';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandXXS, LabelS } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_MARKET_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { useDeeplinkFromNativeApp } from '@sorare/core/src/hooks/useDeeplinkFromNativeApp';
import { useGetInteractionContext } from '@sorare/core/src/hooks/useGetInteractionContext';
import { onboarding } from '@sorare/core/src/lib/glossary';

import { useSkipOnboardingMutation } from '@sorare/gameplay/src/hooks/onboarding/useSkipOnboardingMutation';

import { ExpertModeWarningDialog } from 'components/commonGame/UnlockPro/ExpertModeWarningDialog';

const Root = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--double-unit);
  padding: var(--double-unit);
  border-radius: var(--unit);
  background: var(--c-nl-500);
  border: 1px solid var(--c-nd-150);
  &:hover {
    background: var(--c-nd-100);
  }
  transition: 300ms background-color ease-in-out;
`;
const TextWrapper = styled(Vertical).attrs({ gap: 0.5 })`
  align-items: flex-start;
`;

export const Fallback = () => {
  return <Skeleton style={{ height: 62 }} />;
};

export const ExpertBanner = () => {
  const [warningDialogOpen, setWarningDialogOpen] = useState(false);
  const [skipOnboarding] = useSkipOnboardingMutation();
  const { navigateWithDeeplink } = useDeeplinkFromNativeApp();
  const getInteractionContext = useGetInteractionContext();

  return (
    <>
      <Root onClick={() => setWarningDialogOpen(true)}>
        <TextWrapper>
          <BrandXXS>
            <FormattedMessage {...onboarding.expert} />
          </BrandXXS>
          <LabelS color="var(--c-nd-700)">
            <FormattedMessage {...onboarding.expertDescription} />
          </LabelS>
        </TextWrapper>
        <ChevronRightBold />
      </Root>
      {!!warningDialogOpen && (
        <ExpertModeWarningDialog
          onClose={() => setWarningDialogOpen(false)}
          onContinue={async () => {
            setWarningDialogOpen(false);
            await skipOnboarding({
              variables: {
                input: {
                  sport: Sport.FOOTBALL,
                  interactionContext: getInteractionContext(),
                },
                sport: Sport.FOOTBALL,
              },
            });
            navigateWithDeeplink(FOOTBALL_MARKET_INSTANT_BUY);
          }}
        />
      )}
    </>
  );
};
